import { render, staticRenderFns } from "./ResetPinDialogComponent.vue?vue&type=template&id=23cff494&"
import script from "./ResetPinDialogComponent.vue?vue&type=script&lang=js&"
export * from "./ResetPinDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports